import React, {Component} from "react";
import {connect} from "react-redux";
import Translate from "localization/Translate";
import {getTranslate} from "localization/localizeSlice";
import {
    findCustomerByAdditionalInfo,
    findCustomerByCardNumber,
    findCustomerByEmail,
    findCustomerByPhone,
    setDefaultCustomer,
    setLoading,
    setRightPanelFullscreen,
    simulateMemberPoints
} from "../../redux/actions";
import Button from "../../buttons/Button";
import EnterCustomerInfoFullscreen from "../customerSearch/EnterCustomerInfoFullscreen";
import ScanCustomerCountDown from "./ScanCustomerCountDown";
import Image from "../../theme/Image";
import CreateCustomerWithOptIn from "../customerSearch/CreateCustomerWithOptIn";
import {CREATE_ACCOUNT_CLICKED, CUSTOMER_SEARCH_OPENED} from "../../redux/actionTypes";

const mapStateToProps = state => {
    const customer = state.rootReducer.customer;

    return {
        customer,
        customer_code_starts_with: state.rootReducer.erplyConf.touchpos_customer_code_starts_with || false,
        countryCode: state.rootReducer.erplyConf.DKTCountryCode,
        translate: getTranslate(state),
        theme: state.rootReducer.theme,
        enableAddCustomer: () => window?.AppConf?.enableAddCustomer ?? false,
        displayEarnCustomerPoints: () => window?.AppConf?.displayEarnCustomerPoints ?? false,
        accountCreation: () => window?.AppConf?.accountCreation ?? false
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setRightPanelFullscreen: (fullscreen) => {
            dispatch(setRightPanelFullscreen(fullscreen))
        },
        findCustomer: (customer, countryCode) => {
            dispatch(setLoading(true));

            if(typeof customer.email !== "undefined"){
                dispatch(findCustomerByEmail(customer.email, (customer)=>{
                    dispatch(setLoading(false));
                }, (result) => {
                    dispatch(setLoading(false));
                }));
            }else if(typeof customer.phone !== "undefined"){
                dispatch(findCustomerByPhone(customer.phone, countryCode, (customer)=>{
                    dispatch(setLoading(false));
                }, (result) => {
                    dispatch(setLoading(false));
                }));
            }else if((customer?.card_number ?? "") !== ""){
                dispatch(findCustomerByCardNumber(customer.card_number, (customer)=>{
                    dispatch(setLoading(false));
                }, (result) => {
                    dispatch(setLoading(false));
                }));
            }else if(customer.rawData.additional_information.length > 0){
                dispatch(findCustomerByAdditionalInfo(customer.rawData.additional_information[0], () => {
                    dispatch(setLoading(false));
                }, () => {
                    dispatch(setLoading(false));
                }))
            }
        },
        setDefaultCustomer: () => {
            dispatch(setDefaultCustomer());
        },
        oneLoyaltySimulateRequest: (onSuccess, onFailure) => {
            dispatch(simulateMemberPoints(onSuccess, onFailure));
        },
        createAccountClicked: () => {
            dispatch({
                type: CREATE_ACCOUNT_CLICKED
            });
        },
        customerSearchOpened: () => {
            dispatch({
                type: CUSTOMER_SEARCH_OPENED
            });
        }
    }
}

class FullscreenCustomerSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 'scan',
            earnPoints: ''
        };
    }

    _isMounted = false;
    componentDidMount() {
        this._isMounted = true;
        this.props.setRightPanelFullscreen(true);
        if(this.props.displayEarnCustomerPoints()){
            this.props.oneLoyaltySimulateRequest((response) => {
                console.log('oneLoyaltySimulateRequest', {response});
                if(this._isMounted){
                    this.setState({
                        earnPoints: response.points
                    });
                }
            }, (error) => {
                console.log('oneLoyaltySimulateRequest', {error});
            });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.props.setRightPanelFullscreen(false);
    }

    render() {
        if(this.state.view === 'search'){
            return <EnterCustomerInfoFullscreen
                customerCodeStartsWith={this.props.customer_code_starts_with}
                countryCode={this.props.countryCode}
                onBack={() => {
                    this.setState({
                        view: 'scan'
                    });
                }}
                onDone={(customer) => {
                    this.props.findCustomer(customer, this.props.countryCode);
                }}
            />;
        }else if(this.state.view === 'createAccount'){
            return <CreateCustomerWithOptIn
                onBack={() => {
                    this.setState({
                        view: 'scan'
                    });
                }}
            />
        }

        if(this.props.enableAddCustomer()){
            let accountCreation = this.props.accountCreation();
            let benefits;
            if(typeof accountCreation?.benefitsUrl !== "undefined"){
                benefits = <div style={{
                    width: "100%",
                    height: "17.86rem",
                    backgroundImage: `url(${accountCreation.benefitsUrl})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center"
                }}></div>
            }

            let pointsMessage;
            if(this.props.displayEarnCustomerPoints() && this.state.earnPoints !== ''){
                pointsMessage = (
                    <div className={"coloredText"} style={{
                        marginTop: "1.43rem",
                        flexGrow: 1,
                        fontSize: '1.29rem',
                        whiteSpace: "pre-wrap"
                    }}>
                        <Translate id={"Today you can earn ${points} points on this transaction"} values={{points: this.state.earnPoints}}/>
                    </div>
                );
            }

            return (
                <div style={{
                    display: "flex",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0
                }}>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        padding: "2.86rem 1.43rem",
                        boxSizing: "border-box",
                        width: "60%"
                    }}>
                        <div style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            alignItems: "center",
                            whiteSpace: "pre-line",
                            lineHeight: 1.5,
                            marginBottom: "0.71rem"
                        }}>
                            <Translate id={"Scan your Decathlon card"}/>
                        </div>
                        <div style={{
                            alignItems: "center"
                        }}>
                            <div>
                                <Image image={"scanLoyaltyCard"} alt={"customer search"} style={{maxWidth: "50%"}}/>
                                <br/>
                                <ScanCustomerCountDown setDefaultCustomer={this.props.setDefaultCustomer}/>
                            </div>
                        </div>
                        <div style={{
                            flexGrow: "1",
                            alignContent: "center",
                            width: "21.43rem",
                            margin: "auto"
                        }}>
                            <div className={"diagonalLine"} style={{
                                float: "left",
                                marginTop: "2.86rem"
                            }}/>
                            <span className={"coloredText"} style={{
                                textTransform: "uppercase",
                                fontStyle: "italic",
                                fontSize: '1.43rem'
                            }}>
                                <Translate id="or"/>
                            </span>
                            <div className={"diagonalLine"} style={{
                                float: "right",
                                marginTop: "0.71rem"
                            }}/>
                        </div>

                        <div onClick={() => {
                            this.setState({
                                view: 'search'
                            });
                            this.props.customerSearchOpened();
                        }} style={{margin: '1.43rem'}}>
                            <Button type="button" className={"wideButton darkerBlueButton"} name={<Translate id="Add info here"/>}/>
                        </div>
                        <div onClick={this.props.onSkip} style={{margin: '0.43rem'}}>
                            <Button type="button" className={"wideButton grayButton"} name={<Translate id="skip"/>}/>
                        </div>
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        padding: "2.86rem 1.43rem",
                        boxSizing: "border-box",
                        width: "40%"
                    }}>
                        { benefits }
                        <div className={"coloredText"} style={{
                            marginTop: "1.43rem",
                            flexGrow: 1,
                            fontSize: "2rem",
                            whiteSpace: "pre-wrap"
                        }}>
                            <Translate id={accountCreation.message}/>
                        </div>
                        { pointsMessage }
                        <div onClick={() => {
                            this.setState({
                                view: 'createAccount'
                            });
                            this.props.createAccountClicked();
                        }} style={{margin: '1.43rem'}}>
                            <Button type="button" className={"wideButton darkerBlueButton largeRoundButton"} name={<Translate id="Create your account"/>}/>
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "100%",
                padding: "4.29rem 5.71rem",
                boxSizing: "border-box"
            }}>
                <div style={{
                    display: "grid",
                    gridAutoFlow: "column",
                    gridAutoColumns: "1fr",
                }}>
                    <div style={{
                        fontWeight: "bold",
                        textAlign: "left",
                        alignItems: "center",
                        display: "flex",
                        paddingRight: "3.57rem",
                        whiteSpace: "pre-line",
                        lineHeight: 1.5
                    }}>
                        <Translate id={"Scan your loyalty card or search manually"}/>
                    </div>
                    <div style={{
                        height: "34.29rem",
                        alignItems: "center",
                        display: "flex"
                    }}>
                        <div>
                            <Image image={"scanLoyaltyCard"} alt={"customer search"} style={{maxWidth: "100%"}}/>
                            <br/>
                            <ScanCustomerCountDown setDefaultCustomer={this.props.setDefaultCustomer}/>
                        </div>
                    </div>
                </div>
                <div style={{
                    flexGrow: "1"
                }}/>
                <div style={{
                    display: "grid",
                    gridAutoFlow: "column",
                    gridAutoColumns: "1fr",
                }}>
                    <div onClick={() => {
                        this.setState({
                            view: 'search'
                        })
                    }} style={{margin: '0.43rem'}}>
                        <Button type="button" className={"wideButton darkerBlueButton"} name={<Translate id="enter"/>} style={{
                            width: '100%'
                        }}/>
                    </div>
                    <div onClick={this.props.onSkip} style={{margin: '0.43rem'}}>
                        <Button type="button" className={"wideButton grayButton"} name={<Translate id="skip"/>} style={{
                            width: '100%'
                        }}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FullscreenCustomerSearch);
